'use strict';

/*
 * Use on html element which is scrollable, this will not work if the element has overflow: hidden set
 * use as infinite-scroll="CALLBACK()" to load new items and scroll-threshold="NUMERIC VALUE" as offset to bottom of element (determines the point when to load new items)
 */
module.exports = ['$timeout', function ($timeout) {
  return {
    scope: {
      infiniteScroll: '&',
      infiniteScrollContainer: '='
    },
    link: function (scope, element, attr) {
      var
        lengthThreshold = attr.scrollThreshold || 50,
        timeThreshold = attr.timeThreshold || 400,
        promise = null,
        lastRemaining = 9999;
      lengthThreshold = parseInt(lengthThreshold, 10);
      timeThreshold = parseInt(timeThreshold, 10);

      var scroll = function () {

        var scrollHeight = element[0].scrollHeight;// || element[0].scrollingElement.scrollHeight;
        var clientHeight = element[0].clientHeight;// || element[0].scrollingElement.clientHeight;
        var scrollTop = element[0].scrollTop;// || element[0].scrollingElement.scrollTop;
        var remaining = scrollHeight - (clientHeight + scrollTop);
        //if we have reached the threshold and we scroll down
        var condition = (remaining < lengthThreshold && (remaining - lastRemaining) < 0);

        if (scope.infiniteScrollContainer !== undefined) {
          if (scope.infiniteScrollContainer === "document") {
            scrollTop = jQuery(document).scrollTop();
            var windowHeight = jQuery(window).height();
            var bodyHeight = jQuery(document).height() - windowHeight;
            var scrollPercentage = (scrollTop / bodyHeight);

            condition = scrollPercentage > 0.8;
          } else {
            scrollHeight = element[0].scrollHeight;// || element[0].scrollingElement.scrollHeight;
            clientHeight = element[0].clientHeight;// || element[0].scrollingElement.clientHeight;
            scrollTop = element[0].scrollTop;// || element[0].scrollingElement.scrollTop;
            remaining = scrollHeight - (clientHeight + scrollTop);
            //if we have reached the threshold and we scroll down
            condition = (remaining < lengthThreshold && (remaining - lastRemaining) < 0);
          }
        }

        if (condition) {

          //if there is already a timer running which has no expired yet we have to cancel it and restart the timer
          if (promise !== null) {
            $timeout.cancel(promise);
          }
          promise = $timeout(function () {
            scope.infiniteScroll();
            promise = null;
          }, timeThreshold);
        }
        lastRemaining = remaining;
      };

      if (scope.infiniteScrollContainer !== undefined) {
        if (scope.infiniteScrollContainer === "document") {
          element = angular.element(document);
        } else {
          element = angular.element(document).find(scope.infiniteScrollContainer);
        }
      }

      // set event listener
      element.on('scroll', scroll);

      // clean up event listener
      scope.$on('$destroy', function() {
        element.off('scroll', scroll);
      });
    }
  };
}];



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/infinite-scroll.js